import debounce from 'lodash/debounce';

const allImages = document.querySelectorAll('.twoyou-image-container img.image');

Array.from(allImages).forEach(image => {
  const allDataAttrs = image.dataset;

  const handleImageAltTags = debounce(() => {
    const windowWidth = window.innerWidth;

    if (windowWidth < 760) {
      image.setAttribute('alt', allDataAttrs.mobileAlt);
    }

    if (windowWidth >= 760 && windowWidth < 1024) {
      image.setAttribute('alt', allDataAttrs.tabletAlt);
    }

    if (windowWidth >= 1024) {
      image.setAttribute('alt', allDataAttrs.desktopAlt);
    }
  }, 250);

  if (
    allDataAttrs.mobileAlt !== allDataAttrs.tabletAlt &&
    allDataAttrs.mobileAlt !== allDataAttrs.desktopAlt
  ) {
    window.addEventListener('DOMContentLoaded', handleImageAltTags, false);
    window.addEventListener('resize', handleImageAltTags, false);
  }
});
